import { Chart } from "chart.js"
import { RoundedBarPluginV2 } from "./shared/borderRadiusBarCharts";

Chart.pluginService.register(RoundedBarPluginV2);

export interface GcmAlertItem {
    titleName: string;
    projectTotalCount: number;
}
export interface GcmAlerts {
    typeProductAlertGCMInIssues?: GcmAlertItem[];
}

export function buildAlertGCMInIssues(gcmAlerts?: GcmAlerts) {
    const items = gcmAlerts?.typeProductAlertGCMInIssues ?? [];
    const labels = items.map(i => i.titleName);
    const values = items.map(i => i.projectTotalCount);

    const maxX = Math.max(0, ...values);
    const paddedMax = Math.ceil((maxX + 3) / 5) * 5;

    const wrapLabel = (str: string, max = 26): string[] | string => {
        if (!str) return str;
        const words = str.split(' ');
        const lines: string[] = [];
        let line = '';

        for (const w of words) {
            const test = line ? `${line} ${w}` : w;
            if (test.length > max) {
                if (line) lines.push(line);
                if (w.length > max) {
                    const chunks = w.match(new RegExp(`.{1,${max}}`, 'g')) || [w];
                    lines.push(...chunks.slice(0, -1));
                    line = chunks[chunks.length - 1];
                } else {
                    line = w;
                }
            } else {
                line = test;
            }
        }
        if (line) lines.push(line);
        return lines.length ? lines : str;
    };

    const data = {
        labels,
        datasets: [
            {
                label: "CTs warning",
                data: values,
                backgroundColor: "#D0DEF8",
                borderWidth: 0,
                barThickness: 18,
                categoryPercentage: 0.8,
                barPercentage: 0.9,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: { enabled: false },
        plugins: {
            roundedBar: {
                radius: 5,
            },
            datalabels: {
                display: true,
                color: "#1b1f27",
                anchor: "end",
                align: "right",
                offset: 4,
                font: {
                    weight: "600",
                    size: 12
                },
                formatter: (v: number) => v,
                clamp: true,
            },
        },
        scales: {
            yAxes: [{
                ticks: {
                    fontColor: "#3b3b3b",
                    fontSize: 12,
                    lineHeight: 1.2,
                    autoSkip: false,
                    callback: (v: string) => wrapLabel(v, 26) as any,
                },
                gridLines: { display: false },
            }],
            xAxes: [{
                ticks: {
                    beginAtZero: true,
                    fontSize: 12,
                    max: paddedMax,
                    stepSize: 10,
                    fontColor: "#6b7280",
                },
                gridLines: {
                    drawBorder: true,
                    color: "rgba(0,0,0,0.08)",
                    borderDash: [4, 4],
                },
            }],
        },
    };

    return { data, options };
}